import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Apply2 from "../commons/Apply2";

import TopFooter from "../commons/TopFooter";
import icon4 from "../../icons/akiltech.jpg";
import icon5 from "../../icons/email.jpg";
import KhloHome from "./../../Case-studies/khloe-home-decor.pdf";
import CarportCape from "./../../Case-studies/carport-capetown.pdf";
import SwimmingPool from "./../../Case-studies/swimming-pool-installation-capetown.pdf";
import EastgateDental from "./../../Case-studies/eastgate-dental.pdf";
import Swimming from "./../../icons/swimming-pool-installation-capetown.png";
import Download from "./../../icons/download-case-study.png";
import Icone from "./../../icons/icon-software.png";
import Khloe from "./../../icons/khloe-home-decor-zimbabwe.png";
import Carports from "./../../icons/carports-capetown.png";
import Eastgate from "./../../icons/eastgate.png";

const DigitalStrategyFramework = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main>
      {/* <!-- Slider Area Start--> */}
      <div className="slider-area">
        <div className="single-sliders slider-height d-flex align-items-center">
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-xl-7 col-lg-7 col-md-6">
                <div className="hero-caption">
                  <h1>Digital Business Growth Framework</h1>

                  <p>
                   Cut through the noise and jump-start your online game.


                  </p>

                  <Link to="/services" className="btn hero-btn">
                    BOOK FREE BRIEFING SESSION
                  </Link>
                </div>
              </div>
              {/* <!-- hero shape 2--> */}
            </div>
          </div>
        </div>
        <div className="  d-flex ">
          <div className="container position-relative">
            <div className="row ">
              <div className="col-xl-5 col-lg-6 col-md-6  mouse_scroll  "></div>
              {/* <!-- hero shape 2--> */}
              <div className="">
                <div className="header-social text-white ">
                  <a className="text-white" href="#a">
                    Follow us on:
                  </a>
                  <a
                    href="https://www.facebook.com/akiltechspecialities/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="text-white fab fa-facebook-square"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/akiltech_inc/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className=" text-white fab fa-instagram-square"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/akiltech-incoparated"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="text-white fab fa-linkedin-in"></i>
                  </a>
                  <a
                    href="https://twitter.com/AkilTech_inc"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className=" text-white fab fa-twitter-square"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- social --> */}
      </div>
      {/* <!-- Slider Area End -->
    <!-- Services Area Start --> */}
      <section className="categories-area section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <h2><strong>Deciding what To Focus On To Market And Grow Your Business Can Be Challenging</strong></h2>
            <p className="mt-2">
              For many founders, small business owners, and marketing teams, navigating today’s digital landscape can feel like finding your way through a maze. With so many new tools and technologies and no shortage of ‘hype,’ it’s hard to know where to begin. You know what you need: scalable exposure, qualified leads, increased revenue, more capabilities, and less overhead. But where best to invest your time and resources to make it happen? 
            </p>
            <div className="row mt-3">
             
              <div className="col-lg-12">
                <h2><strong>Get Clarity And Save Time With A Digital Strategy Playbook</strong></h2>
                <p className="mt-3">
                Consider the benefits of a well-defined strategy that provides a clear direction for your digital presence — no more guesswork. Just time-saving clarity highlighting your position in the market, how to structure your website, what tools and technologies to use, and the opportunities for what works best for your business. 
                </p>
              
               {/* <div className="section-tittle text-center mb-60">
                  <h2>
                    If you want a website that speaks your language, contact us
                    today.{" "}
                  </h2>

                  <a href="request" className="border-btn">
                    Talk To Us
                  </a>
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
      </section>
               <h3 className="text-center mb-3 "> <strong> A few of the things you will learn:</strong> </h3>

      <div className="row ">
      <div className="col-lg-6 call-blue">

        <div class="col-12">
          <div class="service-box text-white">
            <img src={Icone} height="30" />{" "}
            <div class="service-content">
              <p className="text-white">
                <strong>
                  What you should focus on and in what order.
                </strong>{" "}
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="service-box text-white">
            <img src={Icone} height="30" />
            <div class="service-content">
              <p>
                <strong>
                  A single point of contact, proven processes, and seasoned pros
                  to plan and build your site.
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />
            <div class="service-content">
              <p>
                <strong>
                  What to do about your online reputation
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />
            <div class="service-content">
              <p>
                <strong>
                  We map out a clear, actionable roadmap for your growth,
                  ensuring you’re prepared for what’s next.
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />
            <div class="service-content">

              <p>
                <strong>
                  We'll show you exactly what you need to level up your game
                  quickly and efficiently.
                </strong>
              </p>
            </div>
          </div>
        </div>

      </div>
      <div className="col-lg-6">
     

        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />{" "}
            <div class="service-content">
              <p>
                <strong>
                  Treat clients as numbers with a one-size-fits-all mindset leaving you lost in the system.
                </strong>{" "}
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />
            <div class="service-content">
              <p>
                <strong>
                 Makeshift solutions that cost more in time and resources without delivering depth or value.
                </strong>
              </p>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />
            <div class="service-content">
              <p>
                <strong>
                 Weeks or months without updates, leaving you in the dark.
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />
            <div class="service-content">
              <p>
                <strong>
                 A glaring absence of growth strategy, with no foresight or planning for your business’s future.
                </strong>
              </p>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="service-box">
            <img src={Icone} height="30" />
            <div class="service-content">

              <p>
                <strong>
                  Focused on selling the latest fad, not what best serves your business.
                </strong>
              </p>
            </div>
          </div>
        </div>

      </div>
      </div>
      <div className="call-blue text-center">
        <h2 className="text-white text-center mt-5">
          Say goodbye to AMATEUR, OUTDATED & poor-performing websites
        </h2>
        <a
          href="https://calendly.com/mushaitapiwanashe/briefing-session"
          className="btn mt-20"
        >
          Schedule a Meeting
        </a>
      </div>
      <div className="call-blue text-center">
        <h2 className="text-white text-center mt-5">
          We are passionate about serving our clients !
        </h2>
        <h5 className="text-white text-center">
          Case Studies - Our successful campaigns
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Swimming} className="img-fluid" alt="" />
            <div className="cat-cap">
              <h4 className="mt-3">
                <a href="services">
                  <strong>
                    Search Marketing Case Study: Pool Installation and Repairs
                  </strong>
                </a>
              </h4>

              <p className="mt-3">
                A South African company offering pool installation , pool
                building , pool repairs to pool cleaning services commissioned
                Akiltech’s services to setup it's digital footprint ,online
                presence , grow it’s rankings on Google and increase engagement
                with its target audience across digital platforms.{" "}
              </p>
            </div>
            <a
              href={SwimmingPool}
              download="Swimming Pool Installation Capetown Case Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Carports} className="img-fluid" alt="" />
            <div className="cat-cap mt-3">
              <h4>
                <a href="services">
                  <strong>
                    Search Engine Optimization Case Study: Carports & Shadeports
                    Contractors
                  </strong>
                </a>
              </h4>

              <p className="mt-3">
                A South African company providing residential and commercial
                carports and shadeports installation services in Western Cape.
                It commissioned Akiltech’s services to setup online presence,
                increase Google market share, rankings and online conversions.{" "}
              </p>
            </div>
            <a
              href={CarportCape}
              download="Carports-Capetown-Case-Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Eastgate} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href="https://safaristourafrica.com/">
                  <strong>
                    Digital Businness Growth Case Study: Safaris Tour Africa,
                    United Kingdom
                  </strong>
                </a>
              </h4>
              <p>
                A Dental practice in Harare CBD which provides a full spectrum
                of dental services. It commissioned Akiltech’s services to setup
                it's digital footprint ,online presence and increase it’s
                visibility on Googele.
              </p>
            </div>
            <a
              href={EastgateDental}
              download="Eastgate Dental Case Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Khloe} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href={KhloHome} download="Khole-home-decor">
                  <strong>
                    Website Dev & GBM Case Study: Home Interiors | Curtains
                  </strong>
                </a>
              </h4>
              <p className="mt-3">
                Khloe's Home & Décor is a Zimbabwean private owned company
                specialising in Home Interiors.Core business is curtaining,
                providing to both households and organisations. It was founded
                in 2017 by a young woman who had a passion for home decor and
                office improvements.Khloe commissioned Akiltech’s services to
                setup google and internet presence.
              </p>
            </div>
            <a
              href={KhloHome}
              download="Khole-home-decor Case Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Eastgate} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href="services">
                  <strong>
                    Digital Businness Growth Case Study: Precision Maintenance,
                    United Kingdom
                  </strong>
                </a>
              </h4>
              <p>
                A Dental practice in Harare CBD which provides a full spectrum
                of dental services. It commissioned Akiltech’s services to setup
                it's digital footprint ,online presence and increase it’s
                visibility on Googele.
              </p>
            </div>
            <a
              href={EastgateDental}
              download="Eastgate Dental Case Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Eastgate} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href="https://safaristourafrica.com/padanda-resort/">
                  <strong>
                    Digital Businness Growth Case Study: Padanda Resort , Nyanga
                  </strong>
                </a>
              </h4>
              <p>
                Interested in traveling to Nyanga with your family or kids, in a
                small group, or by yourself? We provide a 3-bedroom
                accommodation at Padanda Resort and you're welcome to bring your
                own tent or camper for outdoor camping. We provide a variety of
                fun activities such as tractor rides, quad biking, honey,trout
                fishing, hiking, cycling, and safari tours.{" "}
              </p>
            </div>
            <a
              href={EastgateDental}
              download="Eastgate Dental Case Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Eastgate} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href="https://premiumfencing.co.za/">
                  <strong>
                    Website Dev & SEO Case Study: Fencing & Gates Company, South
                    Africa
                  </strong>
                </a>
              </h4>
              <p>
                A Dental practice in Harare CBD which provides a full spectrum
                of dental services. It commissioned Akiltech’s services to setup
                it's digital footprint ,online presence and increase it’s
                visibility on Googele.
              </p>
            </div>
            <a
              href={EastgateDental}
              download="Eastgate Dental Case Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-cat text-left mb-20">
            <img src={Eastgate} className="img-fluid" alt="" />

            <div className="cat-cap mt-3">
              <h4>
                <a href="services">
                  <strong>
                    Digital Businness Growth Case Study: Dagmar Helping Hands
                  </strong>
                </a>
              </h4>
              <p>
                Interested in traveling to Nyanga with your family or kids, in a
                small group, or by yourself? We provide a 3-bedroom
                accommodation at Padanda Resort and you're welcome to bring your
                own tent or camper for outdoor camping. We provide a variety of
                fun activities such as tractor rides, quad biking, honey,trout
                fishing, hiking, cycling, and safari tours.{" "}
              </p>
            </div>
            <a
              href={EastgateDental}
              download="Eastgate Dental Case Study"
              className="btn mt-20"
            >
              DOWNLOAD CASE STUDY <img src={Download} />
            </a>
          </div>
        </div>
      </div>
      <section className="categories-area section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-6 col-md-10">
              {/* During our discovery session, we work together to identify
                       the key website performance metrics that are important to
                        your business. Using this information, we establish clear
                         goals and thoroughly assess and improve the performance
                          of your website. It is also about showcasing what is most important to your 
                       customers.<!-- Section Tittle -->Not all detail is appropriate for all audiences; consider who you are
writing for */}
              <div className="section-tittle text-center mb-25">
                <span>Websites That Sells</span>
                <h2>Not sure what you need?</h2>
              </div>
            </div>
          </div>

          <p className="container mt-3">
           That’s okay! We’ve got you. That’s exactly what our Digital Strategy Playbook is designed to uncover—helping you find the best path forward. Check it out here or drop us a note if you have questions. Imagine <strong>building a website</strong> like you would build
            your family home. Would you build a house by yourself? Would you
            hire newbies who build houses in their spare time? Or would you hire
            a team of expert professionals with years of skill in their
            respective fields to ensure quality care was taken with your home?
            You wouldn’t take shortcuts and freebies to build your family home.
            Why do that with your company’s virtual “home?” Isn’t your business
            – like your home -- worth the investment? Book a free briefing
            session and get some business web solutions from Akiltech Inc.
          </p>
        </div>
      </section>
      {/* <!-- Services Area End -->
    <!---Start a project--> */}{" "}
      <div className="container-fluid call-bg">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-9  col-md-12">
            {/* <!-- Section Tittle --> */}
            <div className="section-tittle text-center mb-60">
              <h2>
               Ready to get started?
It all begins with a Digital Business Growth Framework
              </h2>

              <a href="request" className="border-btn2">
                Schedule Free Briefing Session
              </a>
            </div>
          </div>
        </div>
      </div>
      <section className="categories-area section-padding">
        <div className="row container">
          <div className="col-lg-6">
            <img className="img-fluid" src={icon5} />
          </div>
          <div className="col-lg-6">
            {/* <!-- Section Tittle --> */}
            <div className="section-tittle text-center mb-25 mt-3">
              <span>Why Search Engine Optimization is a Great Investment</span>
              <h2>A Website That Doesn't Bring Client Is Useless </h2>
            </div>

            <p>
              All business owners want more bang for their buck. All want better
              profit margins. SEO saves you money. Consider SEO as an employee:
              SEO never clocks out. SEO never calls in sick. SEO never takes a
              holiday. SEO works for you around the clock, even when you’re
              sleeping. No, SEO won’t answer the phone. But it will keep the
              phone ringing. SEO done right will funnel customers to your
              website and put them in front of your products, services and
              brand.
            </p>
          </div>
        </div>
      </section>
      <div
        style={{ marginTop: "0" }}
        className="count-down-area section-padding border-bottom"
      >
        <section className="about-area2 section-padding gray-bg">
          <div className="count-down-area section-padding border-bottom">
            <div className="container-fluid gray-bg">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-9  col-md-12">
                  <div className="section-tittle text-center mb-60">
                    <h2>Interested in discussing a project? </h2>

                    <a href="request" className="border-btn">
                      Get in Touch
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="categories-area section-padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-6 col-md-10">
                {/* <!-- Section Tittle --> */}
                <div className="section-tittle text-center mb-25">
                  <span>
                    Why Search Engine Optimization is a Great Investment
                  </span>
                  <h2>Frequently Bought Together </h2>
                </div>
              </div>
              <p>
                <strong>Website + SEO</strong> (the sooner you start SEO on your
                website the better as the informatino architecture (IA) of your
                website is important to the structure development and ranking of
                your website. This is an ongoing process of small incremental
                changes which lead to small increments over time, but result in
                large gains.
              </p>
              <p>
                <strong>Website + Google Ads</strong> (Often clients require a
                quick and effective solution to get traffic to their website.
                This can be achieved through Google Ads. It is a good option to
                get new business fast.)
              </p>
              <p>
                <strong>Website + SEO + Google Ads</strong> (If your budget
                allows, this is the best combination for short term and long
                term goals for website traffic, leads or sales.)
              </p>
              <p>
                All business owners want more bang for their buck. All want
                better profit margins. SEO saves you money. Consider SEO as an
                employee: SEO never clocks out. SEO never calls in sick. SEO
                never takes a holiday. SEO works for you around the clock, even
                when you’re sleeping. No, SEO won’t answer the phone. But it
                will keep the phone ringing. SEO done right will funnel
                customers to your website and put them in front of your
                products, services and brand.
              </p>
            </div>
            <div className="row"></div>
          </div>
        </section>
        {/* <!-- About Area End -->
      <!--Services Area 2 --> */}
        <section className="services-area2 section-padding2">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-xl-5 col-lg-5 col-md-6 col-sm-11">
                {/* <!-- Section Tittle --> */}
                <div className="section-tittle section-tittle2 mb-55">
                  <span>Industries We Serve</span>
                  <h2>Software Development services </h2>
                </div>
              </div>
              <div className="col-xl-5 col-lg-5 col-md-6 col-sm-11">
                {/* <!-- Section Tittle --> */}
                <div className="section-tittle section-tittle2 mb-55">
                  <p>
                    No matter the business, AkilTech has you covered with
                    industry compliant solutions, customized to your company’s
                    specific needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack1.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#r">Industries & Manufacturing</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack2.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#r">Education & Health</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack3.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#r">Retail & Ecommerce</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="single-cat mb-30 text-center">
                  <div className="cat-icon">
                    <img src="assets/img/icon/stack4.svg" alt="" />
                  </div>
                  <div className="cat-cap">
                    <h5>
                      <a href="#e">Travel & Hospitality</a>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack1.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#s">Media and Entertainment</a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack2.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#a">Public Services & FinTech</a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack3.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#a"> Software as a Service & SMEs</a>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="single-cat mb-30 text-center">
                    <div className="cat-icon">
                      <img src="assets/img/icon/stack4.svg" alt="" />
                    </div>
                    <div className="cat-cap">
                      <h5>
                        <a href="#a">Agriculture & Real Estate</a>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-12">
                  <div className="section-tittle section-tittle3 text-center pt-35">
                    <p>
                      Need a Technology support or to discuss a project ?{" "}
                      <a href="request">Get Started Now</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Apply2 />
      </div>
      <TopFooter />
    </main>
  );
};

export default DigitalStrategyFramework;
